import {doHttpRequest} from "../util/NetUtil";

export const net_createAbstractSubmission = (payload, handler, errorHandler) => {

    doHttpRequest(
        "/abstract/create",
        payload,
        handler,
        errorHandler
    )
}